import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const accessoriesSlice = createSlice({
  name: "accessories",
  initialState,
  reducers: {
    addAccessories(state, action) {
      return [...state, action.payload];
    },
    removeAccessories(state, action) {
      state = action.payload;
      return state;
    },
  },
});

/** Actions */
export const { addAccessories, removeAccessories } = accessoriesSlice.actions;

/** Selectors */
export const getAccessories = (store) => store.accessories;
